// extracted by mini-css-extract-plugin
export var dots = "colorSwapper-module--dots--i+kmn";